import React, { useContext, useState, useEffect } from 'react';
import { Card } from '@rewind-ui/core';
import { Button, Spinner } from 'flowbite-react';
import { TbCircleArrowRightFilled } from 'react-icons/tb';
import { FaXmark } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../modules/contexts/AppContexts';

const AccountTypeSelector = () => {
    const [user, setUserState] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { setStartAuth, updateUserType, setAuthStep } = useContext(AppContext);

    // Only selection logic remains
    const hasSelected = user !== null;

    const closeMethod = () => {
        setStartAuth(false);
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setError('No authentication token found. Please log in again.');
            setStartAuth(true);
            setAuthStep('login');
        }
    }, []);

    const handleContinue = async () => {
        if (!user || loading) return;
        try {
            setLoading(true);
            setError(null);
            const token = localStorage.getItem('token');
            if (!token) {
                setError('No authentication token found. Please log in again.');
                return;
            }
            await updateUserType(user);
            setTimeout(() => {
                closeMethod();
                window.location.href = '/vetting';
            }, 500);
        } catch (err) {
            setError(`Failed to update account type: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] py-2 bg-gray-50">
            <button onClick={closeMethod} className='mb-2 self-center text-gray-400 hover:text-red-500 transition-colors focus:outline-none focus:ring-2 focus:ring-red-200 rounded-full'>
                <FaXmark size={24} />
            </button>
            <Card size='lg' className='flex flex-col border bg-white rounded-2xl shadow-lg p-4 sm:p-6 md:p-8 w-full max-w-md'>
                <div className='flex flex-col items-center gap-8'>
                    <h2 className='text-2xl font-bold text-gray-800 mb-2 text-center'>Select Account Type</h2>
                    <div className='flex w-full gap-4'>
                        <button
                            onClick={() => setUserState('Idea')}
                            className={`flex-1 flex flex-col items-center justify-center py-6 rounded-xl border-2 transition-all duration-200 text-lg font-medium shadow-sm ${
                                user === 'Idea'
                                    ? 'bg-green-500 border-green-600 text-white scale-105 shadow-md'
                                    : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            <span className="text-3xl mb-2">💡</span>
                            Idea
                        </button>
                        <button
                            onClick={() => setUserState('Business')}
                            className={`flex-1 flex flex-col items-center justify-center py-6 rounded-xl border-2 transition-all duration-200 text-lg font-medium shadow-sm ${
                                user === 'Business'
                                    ? 'bg-green-500 border-green-600 text-white scale-105 shadow-md'
                                    : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            <span className="text-3xl mb-2">🏢</span>
                            Business
                        </button>
                    </div>
                    <Button
                        onClick={handleContinue}
                        pill
                        color='success'
                        disabled={loading || !hasSelected}
                        className='w-full mt-4 text-lg font-semibold flex items-center justify-center gap-2 py-3'
                    >
                        Continue
                        {loading ? <Spinner className='ms-2' /> : <TbCircleArrowRightFilled className='text-xl ms-2' />}
                    </Button>
                    {error && (
                        <div className="w-full bg-red-100 border border-red-300 text-red-700 px-4 py-2 rounded mt-2 text-center text-sm">
                            {error}
                        </div>
                    )}
                </div>
            </Card>
        </div>
    );
};

export default AccountTypeSelector;